import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-10b4cb68"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "navbar"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "85%"
  }
};
const _hoisted_3 = {
  key: 1,
  style: {
    "display": "flex"
  }
};
const _hoisted_4 = {
  class: "navbar-right"
};
import Hamburger from '@/layout/headers/components/hamburger.vue';
import Breadcrumb from '@/layout/headers/components/breadcrumb.vue';
import Avatar from '@/layout/headers/components/avatar.vue';
import Lang from '@/layout/headers/components/lang.vue';
import ScreenFull from '@/layout/headers/components/screenFull.vue';
import Driver from '@/layout/headers/components/driver/index.vue';
import Setting from '@/layout/headers/components/setting.vue';
import Menu from '@/layout/menu/index.vue';
import { computed } from 'vue';
import store from '@/store';
// 监听菜单模式
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const menuType = computed(() => {
      if (store.getters.moshiNum === undefined) {
        return localStorage.getItem('changeMoshi') || 1;
      } else {
        return store.getters.moshiNum || 1;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(menuType) === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(Menu)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(Hamburger), _createVNode(Breadcrumb)])), _createElementVNode("div", _hoisted_4, [_createVNode(Driver, {
        class: "navbar-item"
      }), _createVNode(ScreenFull, {
        class: "navbar-item"
      }), _createVNode(Lang, {
        class: "navbar-item"
      }), _createVNode(Avatar, {
        class: "navbar-item"
      }), _createVNode(Setting, {
        class: "navbar-item"
      })])]);
    };
  }
});